import React, { useState, useEffect } from 'react';
import { Card, List, Tag, Spin, Typography, Empty, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const { Text } = Typography;

const VencimientosCard = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchVencimientos();
    }, []);

    const fetchVencimientos = async () => {
        try {
            const response = await api.get('/dashboard/vencimientos');
            if (Array.isArray(response.data)) {
                setData(response.data);
            } else {
                console.error('Data formato incorrecto', response.data);
                setData([]);
            }
        } catch (error) {
            console.error('Error fetching vencimientos:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (dias) => {
        if (dias < 0) return 'red';
        if (dias <= 30) return 'orange';
        return 'green';
    };

    return (
        <Card
            title={<Space><WarningOutlined style={{ color: '#faad14' }} /> Vencimientos Próximos</Space>}
            extra={<a onClick={() => navigate('/gestion-documental')}>Ver todo</a>}
            bodyStyle={{ padding: 0, height: 300, overflowY: 'auto' }}
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: 20 }}>
                    <Spin />
                </div>
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    locale={{ emptyText: <Empty description="No hay vencimientos próximos" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                    renderItem={(item) => (
                        <List.Item style={{ padding: '10px 20px' }}>
                            <List.Item.Meta
                                avatar={<Tag color={getStatusColor(item.dias_restantes)}>{item.subtipo}</Tag>}
                                title={<Text strong>{item.titulo}</Text>}
                                description={
                                    <Space direction="vertical" size={0} style={{ width: '100%' }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>{item.mensaje}</Text>
                                        {item.dias_restantes < 0 ?
                                            <Text type="danger" style={{ fontSize: 12 }}>Vencido hace {Math.abs(item.dias_restantes)} días</Text> :
                                            <Text type="warning" style={{ fontSize: 12 }}>Vence en {item.dias_restantes} días</Text>
                                        }
                                    </Space>
                                }
                            />
                        </List.Item>
                    )}
                />
            )}
        </Card>
    );
};

export default VencimientosCard;
